export default "__VITE_ASSET__viCSENQE__"